<template>
  <div>
    <van-cell-group>
      <van-field
        v-model="question"
        label="咨询"
        type="textarea"
        placeholder="请输入您的想咨询的问题"
        autosize
        :border="false"
        style="min-height:150px;"
      />
    </van-cell-group>
    <van-button type="primary" size="large" @click="submitSuggestion">
      提交
    </van-button>
  </div>
</template>
<script type="text/javascript">
import { addConsultation } from '@/api/other'
import { Toast } from 'vant'
import { mapGetters } from 'vuex'
export default {
  components: {},
  data() {
    return {
      question: '',
      webUserInfoId: ''
    }
  },
  computed: {
    ...mapGetters(['webUserInfo'])
  },
  mounted() {
    console.info(this.webUserInfo)
    this.webUserInfoId = this.webUserInfo.id
  },
  methods: {
    submitSuggestion() {
      const webUserId = this.webUserInfoId // 用户id
      console.info(webUserId)
      if (!webUserId) {
        Toast.fail('请先进行实名认证')
        return
      }
      if (!this.question) {
        Toast.fail('内容不能为空')
        return
      }
      addConsultation({
        webUserId: webUserId, // 用户id
        question: this.question // 内容
      }).then(() => {
        Toast.success('提交成功')
        setTimeout(() => {
          // 跳转页面
          this.$router.push({
            path: '/'
          })
        }, 1500)
      })
    }
  }
}

</script>
<style lang="scss" scoped>
  .consultation-add-container {
    background-color: #eee;
  }
</style>
